import { TAutomationsMode } from '~/types/server.types';

export class AutomationsModeModel {
    automationsMode: TAutomationsMode;

    constructor(automationsMode: TAutomationsMode) {
        this.automationsMode = automationsMode;
    }

    get isNewAutomationsEnabled() {
        const modes: TAutomationsMode[] = ['activated_new', 'new'];
        return modes.includes(this.automationsMode);
    }

    get isUsingOldAutomations() {
        const modes: TAutomationsMode[] = ['old', 'explore_new', 'reverted'];
        return modes.includes(this.automationsMode);
    }

    get isNewAutomationsAccessible() {
        const modes: TAutomationsMode[] = [
            'explore_new',
            'activated_new',
            'new',
            'reverted'
        ];
        return modes.includes(this.automationsMode);
    }

    get isOldAutomationsAccessible() {
        const modes: TAutomationsMode[] = [
            'old',
            'explore_new',
            'activated_new',
            'reverted'
        ];
        return modes.includes(this.automationsMode);
    }

    get hasDualAutomations() {
        return (
            this.isNewAutomationsAccessible && this.isOldAutomationsAccessible
        );
    }

    get isExploreNew() {
        return this.automationsMode === 'explore_new';
    }
}
